import "./PreviousAttendance.css";
import React, { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PreviousAttendanceViewModel from "./PreviousAttendanceViewModel";
import { Avatar } from "@mui/material";
import { StringAvatar } from "../../../../Helpers/StringAvatar";

const PreviousAttendance = () => {
  const navigate = useNavigate();

  const { FinalResult, AttendanceDate, componentRef, handlePrint } =
    PreviousAttendanceViewModel();

  const [NameFilter, setNameFilter] = useState("");
  const [StatusFilter, setStatusFilter] = useState("");

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper previous-attendance-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">View Single Day Attendance</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">
                    View Single Day Attendance
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name..."
                    onChange={(e) => {
                      setNameFilter(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Attendance Status ..."
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                    }}
                  />
                </div>
              </div>

              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">
                          View Single Day Attendance
                        </h3>
                      </div>
                      <div className="col-auto text-end float-end ms-auto download-grp">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handlePrint}
                        >
                          PRINT
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  <table
                    ref={componentRef}
                    className="table border-0 star-student table-hover table-center mb-0 datatable table-striped"
                  >
                    <thead className="student-thread">
                      <tr>
                        <th>Profile</th>
                        <th>Name</th>
                        <th>Date</th>
                        <th className="text-end">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {FinalResult &&
                        FinalResult.filter(
                          (item) =>
                            NameFilter === "" ||
                            `${item.FirstName} ${item.LastName}`
                              .toLowerCase()
                              .includes(NameFilter.toLowerCase())
                        )
                          .filter((item) =>
                            StatusFilter === "" || item.IsPresent
                              ? "Present"
                                  .toLowerCase()
                                  .includes(StatusFilter.toLowerCase())
                              : "Absent"
                                  .toLowerCase()
                                  .includes(StatusFilter.toLowerCase())
                          )
                          .map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <Avatar
                                    className="string-avatar"
                                    {...StringAvatar(
                                      item?.FirstName + " " + item?.LastName
                                    )}
                                  />
                                </td>
                                <td className="text-capitalize">
                                  {item.FirstName + " " + item.LastName}
                                </td>
                                <td>
                                  {AttendanceDate.toDate().toLocaleString(
                                    "en-GB",
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    }
                                  )}
                                </td>

                                <td className="text-end">
                                  <div className="actions">
                                    <p>
                                      {item.IsPresent ? "Present" : "Absent"}
                                    </p>
                                    {/* <Link className="btn btn-sm bg-success-light me-2 present-absent">
                                  
                                  </Link> */}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default PreviousAttendance;
